export { default } from './GridHistoricalFigures.vue'
